import { Injectable } from '@angular/core';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { HttpClient } from '@angular/common/http';
import {
    ApiResponseModel,
    ApiVisa,
  } from "../../../shared";import { Observable } from 'rxjs';
import { FilesDetailsRequest } from '../../../../../../../models/file-image';
import { Optional } from 'typescript-optional';
import { BaseApiPublicLoginTemplateService } from '../../../shared/base-api-public-login-template.service';
import { DeliveryJobCustomStatusHdrContainer } from '../../../../../../../models/aggregates/erp/delivery/job-shipment/delivery-job-custom-status-hdr-container.model';

@Injectable({
  providedIn: 'root'
})
export class DeliveryJobCustomStatusHdrService extends BaseApiPublicLoginTemplateService<DeliveryJobCustomStatusHdrContainer,DeliveryJobCustomStatusHdrContainer,DeliveryJobCustomStatusHdrContainer> {


  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'del/job-custom-status/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'del/job-custom-status/backoffice-ep';
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'del/job-custom-status/login-ep';
    this.httpClient = http;
  }

  getAttachmentFile(guid: string, apiVisa: ApiVisa): Observable<Blob> {
    let url;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'del/job-custom-status/file/backoffice-ep/' + guid;
    }
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(apiVisa)
    );
  }

  public addAttachment(hdrGuid: string, file: File, visa: ApiVisa,
    filesDetails: Optional<FilesDetailsRequest>): Observable<ApiResponseModel<any>> {
    let url;

    if (this.endpoint_path && visa.api_domain_url) {
        url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'del/job-custom-status/add-file/backoffice-ep/' + hdrGuid;
    }

    const formData: FormData = new FormData();
    if (file) {
      formData.append('file', file);
      filesDetails.ifPresent(details =>
        formData.set(
          'file-data',
          new Blob([JSON.stringify(details)], { type: 'application/json' }),
          'file-data.json'));
    }

    return this.httpClient.put<ApiResponseModel<any>>(
        visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'del/job-custom-status/add-file/backoffice-ep/' + hdrGuid,
        formData,
        this.getHttpHeader(visa)
      );
    }

    public updateAttachment(attachmentGuid: string, file: File, visa: ApiVisa,
        filesDetails: Optional<FilesDetailsRequest>): Observable<ApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
    
        const formData: FormData = new FormData();
        if (file) {
          formData.append('file', file);
          filesDetails.ifPresent(details =>
            formData.set(
              'file-data',
              new Blob([JSON.stringify(details)], { type: 'application/json' }),
              'file-data.json'));
        }
    
        return this.httpClient.put<ApiResponseModel<any>>(
            this.apiUrl + '/replace-file/backoffice-ep/' + attachmentGuid,
            formData,
            this.getHttpHeader(visa)
          );
        }

   
        

}
